var map = {
	"./1.png": "2439",
	"./113.png": "8468",
	"./182.png": "ad82",
	"./204.png": "3268",
	"./5.png": "020cf",
	"./521.png": "e1ee",
	"./53.png": "c454",
	"./8.png": "2000",
	"./start_bg.png": "3a6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9a7";